module.exports = __webpack_public_path__ + "img/icon-bell.670041fc.svg";